import { IconComponent } from '../icon.types';

export const DownloadIcon: IconComponent = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_388_1302)">
      <path
        d="M23.94 13L14.13 23.11C13.55 23.69 12.79 24 11.99 24C11.19 24 10.43 23.69 9.86998 23.12L0.0599788 13L6.98998 13L6.98998 -3.0292e-07L16.99 -7.40034e-07L16.99 13L23.94 13Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_388_1302">
        <rect
          width="24"
          height="24"
          fill="currentColor"
          transform="translate(0 24) rotate(-90)"
        />
      </clipPath>
    </defs>
  </svg>
);
